import {
  IonButtons,
  IonTitle,
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
  IonBackButton,
  useIonViewWillEnter,
  IonButton,
} from "@ionic/react";
import React from "react";
import { useDispatch } from "react-redux";
import { findOrganizations } from "../../store/organizations/actions/findOrganizations";
import { ListSection } from "./components/ListSection";

export const OrganizationList: React.FC = () => {
  const dispatch = useDispatch();

  useIonViewWillEnter(() => {
    dispatch(findOrganizations());
  });

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton color="light" defaultHref="/app/gerencia" />
          </IonButtons>
          <IonTitle>Mis clientes</IonTitle>
          <IonButtons slot="end">
            <IonButton routerLink="/app/gerencia/mis-clientes/nuevo">Nuevo</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <ListSection />
      </IonContent>
    </IonPage>
  );
};
